import { render } from "./TeamStatistics.vue?vue&type=template&id=c9ecd016&scoped=true"
import script from "./TeamStatistics.vue?vue&type=script&lang=js"
export * from "./TeamStatistics.vue?vue&type=script&lang=js"

import "./TeamStatistics.vue?vue&type=style&index=0&id=c9ecd016&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9ecd016"]])

export default __exports__